module.exports = __webpack_public_path__ + "static/media/step1img3.f6459f5e.png";